import React, { useContext } from "react";

import { FileRecordStatus } from "../../../../../common/types/FileRecordStatus";
import { FileRecordStatusDetails } from "../../../common/types/FileRecordStatusDetails";
import { WaitingForClientResponseStatusDialog } from "../../../details/sections/info/library/status/WaitingForClientResponseStatusDialog";
import { FileRecordListingContext } from "../../context/FileRecordListingContext";

interface ChangeSingleFileRecordToWaitingForResponseDialogProps {
    fileRecordId: string;
    onClose(): void;
    isOpen: boolean;
}

export const ChangeSingleFileRecordToWaitingForResponseDialog: React.FC<ChangeSingleFileRecordToWaitingForResponseDialogProps> = ({
    fileRecordId,
    isOpen,
    onClose
}: ChangeSingleFileRecordToWaitingForResponseDialogProps) => {
    const { updateFileRecordStatus } = useContext(FileRecordListingContext);

    const handleConfirm = (statusDetails?: FileRecordStatusDetails) => {
        updateFileRecordStatus(fileRecordId, FileRecordStatus.WaitingForClientResponse, statusDetails);
        onClose();
    };

    return (
        <WaitingForClientResponseStatusDialog
            isOpen={isOpen}
            onClose={onClose}
            fileRecordId={fileRecordId}
            onConfirm={handleConfirm}
        />
    );
};
